import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { useStyles } from "hooks/hooks";

interface Props {
    title: any;
    description: any;
    style?: any;
    rmPadding?: boolean;
    devaultValue?: boolean;
    styleTitle?: any;
    rmTitlePadding?: any;
    onChange?: any;
    expand?: boolean;
}

export default function Acordion({
    title,
    description,
    style,
    styleTitle,
    rmPadding,
    rmTitlePadding,
    devaultValue,
    onChange,
    expand
}: Props) {
    const classes = useStyles({
        root: {
            maxWidth: "1220px !important",
            width: "100%",
            background: "#FFF",
            boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.10)",

            "& .MuiAccordionDetails-root": {
                paddingTop: "0px !important",
                padding: rmPadding ? "0px !important" : "0px 16px 16px 16px !important"
            },
            "& .MuiAccordionSummary-root": {
                padding: rmTitlePadding ? "0px !important" : "0px 16px"
            },
            "& .MuiAccordion-root": {
                margin: "0px !important"
            },
            "& .MuiAccordion-root:before": {
                display: "none !important"
            },
            "& .Mui-expanded": {
                margin: "0px !important"
            },
            "& .MuiAccordionSummary-content": {
                margin: "20px 0px !important",
                border: "none !important"
            },
            "& .MuiPaper-root": {
                margin: "0px !important"
            }
        },

        // MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation1 MuiAccordion-root MuiAccordion-rounded Mui-expanded MuiAccordion-gutters makeStyles-root-131 css-knga1s-MuiPaper-root-MuiAccordion-root
        accordionSummary: {
            margin: "15px 0px !important"
        },
        title: styleTitle || {
            color: "#1F1F1F",
            fontSize: "19px",
            fontWeight: "600"
        },
        description: {
            color: "#1F1F1F",
            fontSize: "15px",
            fontWeight: "400",
            lineHeight: "20px"
        }
    });

    if (onChange) {
        return (
            <Accordion className={classes.root} sx={style} expanded={expand} onChange={onChange}>
                <AccordionSummary
                    aria-controls="panel1d-content"
                    id="panel1d-header"
                    expandIcon={<i className="arrowDownIconGray" />}>
                    {typeof title === "string" ? <b className={classes.title}>{title}</b> : <>{title}</>}
                </AccordionSummary>
                <AccordionDetails>
                    <span className={classes.description}>{description}</span>
                </AccordionDetails>
            </Accordion>
        );
    } else {
        return (
            <Accordion className={classes.root} sx={style} defaultExpanded={devaultValue}>
                <AccordionSummary
                    aria-controls="panel1d-content"
                    id="panel1d-header"
                    expandIcon={<i className="arrowDownIconGray" />}>
                    {typeof title === "string" ? <b className={classes.title}>{title}</b> : <>{title}</>}
                </AccordionSummary>
                <AccordionDetails>
                    <span className={classes.description}>{description}</span>
                </AccordionDetails>
            </Accordion>
        );
    }
}
